// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { WebcamPoster, WebcamPosterDynamic } from './styles';

export const WebcamPreview = ({
  title,
  hdRelayPosterSrc = null,
  fallbackImage = null,
  fallbackImageSrc = null,
  fallbackImageAlt = '',
}) => {
  const [hdRelayPosterFailed, setHdRelayPosterFailed] = useState(false);
  const showHdRelayPoster = Boolean(hdRelayPosterSrc) && !hdRelayPosterFailed;

  useEffect(() => {
    setHdRelayPosterFailed(false);
  }, [hdRelayPosterSrc]);

  if (showHdRelayPoster) {
    return (
      <WebcamPoster
        src={hdRelayPosterSrc}
        alt={title}
        onError={() => setHdRelayPosterFailed(true)}
      />
    );
  }

  if (fallbackImageSrc) {
    return <WebcamPoster src={fallbackImageSrc} alt={fallbackImageAlt || title} />;
  }

  if (fallbackImage) {
    return (
      <WebcamPosterDynamic
        image={fallbackImage}
        alt={fallbackImageAlt || title}
      />
    );
  }

  return null;
};

WebcamPreview.propTypes = {
  title: PropTypes.string.isRequired,
  hdRelayPosterSrc: PropTypes.string,
  fallbackImage: PropTypes.shape({}),
  fallbackImageSrc: PropTypes.string,
  fallbackImageAlt: PropTypes.string,
};
